import { CandidateUDF } from "../common/components/candidateUdf/candidateUdf";
import { CandidateField } from "../common/components/candidateField/candidateField";
import { CandidatePhoneField } from "../common/components/candidatePhoneField/candidatePhoneField";
import { CandidateRecruitersField } from "../common/components/candidateRecruitersField/candidateRecruitersField";
import { CandidateSalaryField } from "../common/components/candidateSalaryField/candidateSalaryField";
import { CandidateSelectField } from "../common/components/candidateSelectField/candidateSelectField";
import { CandidateDateField } from "../common/components/candidateDateField/candidateDateField";
import K from "../utilities/constants";
import { arrayToOptions } from "../utilities/generalUtility";
import { isFinalStatus, isHiredStatus } from "../utilities/candidate";
import { CandidateEmailField } from "../common/components/candidateEmailField/candidateEmailField";

const hireTypeOptions = arrayToOptions(K.CandidateType.getAll());

const candidateUdfToField = (udf) =>
  udf.map((field) => ({
    key: `udf-${field.id}`,
    span: 12,
    udfData: field,
    isUDF: true,
    component: CandidateUDF,
    getProps: (context, field) => ({
      item: field.udfData,
      candidateActivity: context.data,
      styles: context.styles || {},
      extraLabel: context.extraLabel,
      isEditable: context.canEdit,
      disabled: context.disabled,
    }),
  }));

export const getCandidateUdfFields = (udf = []) => candidateUdfToField(udf);

export const getContactFields = () => [
  {
    key: "firstName",
    label: "First Name",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.firstName,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("firstName"),
      disabled: context.disabled,
      required: true,
      validateValue: (rawValue, value) => {
        if (!value) return "First Name is required.";
        return context.validators?.validateNoEdgeSpaces?.(rawValue) ?? null;
      },
    }),
  },
  {
    key: "lastName",
    label: "Last Name",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.lastName,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("lastName"),
      disabled: context.disabled,
      required: true,
      validateValue: (rawValue, value) => {
        if (!value) return "Last Name is required.";
        return context.validators?.validateNoEdgeSpaces?.(rawValue) ?? null;
      },
    }),
  },
  {
    key: "currentTitle",
    label: "Current Title",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.currentTitle,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("currentTitle"),
      disabled: context.disabled,
      validateValue: (rawValue) =>
        context.validators?.validateNoEdgeSpaces?.(rawValue) ?? null,
    }),
  },
  {
    key: "mobileNumber",
    label: "Mobile Number",
    span: 12,
    component: CandidatePhoneField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.mobileNumber,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("mobileNumber"),
      disabled: context.disabled,
    }),
  },
  {
    key: "phoneNumber",
    label: "Additional Phone",
    span: 12,
    component: CandidatePhoneField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.phoneNumber,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("phoneNumber"),
      disabled: context.disabled,
    }),
  },
  {
    key: "location",
    label: "Home Address",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.location,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("location"),
      disabled: context.disabled,
    }),
  },
  {
    key: "email",
    label: "Email Address",
    span: 12,
    component: CandidateEmailField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.email,
      hireType: context.data.hireType,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("email"),
      disabled: context.disabled,
    }),
  },
];

export const getProfessionalFields = () => [
  {
    key: "desireSalary",
    label: "Desired Salary",
    span: 12,
    component: CandidateSalaryField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.desireSalary,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("desireSalary", true),
      disabled: context.disabled,
    }),
  },
  {
    key: "salary",
    label: "Offered Salary",
    span: 12,
    component: CandidateSalaryField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.salary,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("salary", true),
      disabled: context.disabled || context.isOfferedSalaryDisabled?.(),
    }),
  },
  {
    key: "atsLookupId",
    label: "ATS ID",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.atsLookupId,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("atsLookupId", true),
      disabled: context.disabled,
      validateValue: (rawValue) =>
        context.validators?.validateNoEdgeSpaces?.(rawValue) ?? null,
    }),
  },
  {
    key: "hireType",
    label: "Candidate Type",
    span: 12,
    component: CandidateSelectField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.hireType,
      options: hireTypeOptions,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("hireType", true),
      disabled:
        context.disabled ||
        isFinalStatus(context.data.status?.type) ||
        isHiredStatus(context.data.status?.type),
      required: true,
    }),
  },
  {
    key: "candidateStatusesId",
    label: "Candidate Status",
    span: 12,
    component: CandidateSelectField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidateStatusesId,
      options: context.candidateStatusOptions,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("candidateStatusesId", true),
      disabled: context.disabled || context.isStatusDisabled(),
      required: true,
    }),
  },
  {
    key: "sourcesId",
    label: "Source",
    span: 12,
    component: CandidateSelectField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.sourcesId,
      options: context.sourceOptions,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("sourcesId", true, { apiKey: "sourceId" }),
      disabled: context.disabled,
      required: true,
    }),
  },
  {
    key: "candidateJobRecruiters",
    label: "Recruiters",
    span: 12,
    component: CandidateRecruitersField,
    getProps: (context, field) => ({
      label: field.label,
      recruiters: context.data.candidateJobRecruiters,
      availableRecruiters: context.availableRecruiters,
      isEditable: context.canEdit,
      onEdit: context.handleEdit("candidateJobRecruiters", true, {
        stateTransform: context.recruiterStateTransform,
      }),
      disabled: context.disabled || !context.isRecruiterOnJob,
      required: true,
    }),
  },
];

export const getDefaultCandidateFields = (udf = []) => [
  {
    key: "email",
    label: "Email",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.email,
    }),
  },
  {
    key: "phoneNumber",
    label: "Additional Phone",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.phoneNumber,
    }),
  },
  {
    key: "mobileNumber",
    label: "Mobile Number",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.mobileNumber,
    }),
  },
  {
    key: "recruiters",
    label: "Recruiters",
    span: 12,
    component: CandidateRecruitersField,
    getProps: (context, field) => ({
      label: field.label,
      recruiters: context.data.candidateJobRecruiters,
    }),
  },
  {
    key: "location",
    label: "Home Address",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.location,
    }),
  },
  {
    key: "currentTitle",
    label: "Current Title",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.candidate.currentTitle,
    }),
  },
  {
    key: "department",
    label: "Department",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.jobSource?.jobDepartment?.name,
    }),
  },
  {
    key: "atsLookupId",
    label: "ATS ID",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.atsLookupId,
    }),
  },
  {
    key: "desiredSalary",
    label: "Desired Salary",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.desireSalary,
    }),
  },
  {
    key: "offeredSalary",
    label: "Offered Salary",
    span: 12,
    component: CandidateField,
    getProps: (context, field) => ({
      label: field.label,
      value: context.data.salary,
    }),
  },

  {
    key: "interviewConfirmation",
    label: "Interview Confirmation",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "interviewConfirmation",
      isOtherItem: true,
      itemType: K.EditComponentType.CheckBox,
      value: context.data.interviewConfirmation,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },

  {
    key: "sourcedDate",
    label: "Sourced Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "sourcedDate",
      value: context.data.sourcedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },

  {
    key: "firstContactedDate",
    label: "First Contact Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "firstContactedDate",
      value: context.data.firstContactedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "secondContactedDate",
    label: "Second Contact Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "secondContactedDate",
      value: context.data.secondContactedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "thirdContactedDate",
    label: "Third Contact Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "thirdContactedDate",
      value: context.data.thirdContactedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "notIntrestedDate",
    label: "Not Interested Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "notIntrestedDate",
      value: context.data.notIntrestedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "intrestedDate",
    label: "Interested Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "intrestedDate",
      value: context.data.intrestedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "applicationDate",
    label: "Applied Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "applicationDate",
      value: context.data.applicationDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "reviewCompleteDate",
    label: "Review Complete Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "reviewCompleteDate",
      value: context.data.reviewCompleteDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "s2InterviewFirstContactedDate",
    label: "S2 Interview First Contacted Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "s2InterviewFirstContactedDate",
      value: context.data.s2InterviewFirstContactedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "s2InterviewSecondContactedDate",
    label: "S2 Interview Second Contacted Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "s2InterviewSecondContactedDate",
      value: context.data.s2InterviewSecondContactedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "s2InterviewThirdContactedDate",
    label: "S2 Interview Third Contacted Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "s2InterviewThirdContactedDate",
      value: context.data.s2InterviewThirdContactedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "s2InterviewScheduledDate",
    label: "S2 Interview Scheduled Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "s2InterviewScheduledDate",
      value: context.data.s2InterviewScheduledDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "phoneScreenCompleteDate",
    label: "Phone Screen Complete Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "phoneScreenCompleteDate",
      value: context.data.phoneScreenCompleteDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "dateSubmitted",
    label: "Date Submitted",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "dateSubmitted",
      value: context.data.dateSubmitted,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "dateSubmittedFeedbackReceived",
    label: "Submitted Feedback Received Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "dateSubmittedFeedbackReceived",
      value: context.data.dateSubmittedFeedbackReceived,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "schedulingDate",
    label: "Scheduling Interview Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "schedulingDate",
      value: context.data.schedulingDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "interviewDate",
    label: "Interview Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "interviewDate",
      value: context.data.interviewDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "interviewTime",
    label: "Interview Time",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "interviewTime",
      isTime: true,
      value: context.data.interviewTime,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "interviewFeedbackReceived",
    label: "Interview Feedback Received Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "interviewFeedbackReceived",
      value: context.data.interviewFeedbackReceived,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "secondInterviewDate",
    label: "Second Interview Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "secondInterviewDate",
      value: context.data.secondInterviewDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "secondInterviewTime",
    label: "Second Interview Time",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "secondInterviewTime",
      isTime: true,
      value: context.data.secondInterviewTime,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "thirdInterviewDate",
    label: "Third Interview Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "thirdInterviewDate",
      value: context.data.thirdInterviewDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "thirdInterviewTime",
    label: "Third Interview Time",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "thirdInterviewTime",
      isTime: true,
      value: context.data.thirdInterviewTime,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "offerApprovalDate",
    label: "Offer Approval Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "offerApprovalDate",
      value: context.data.offerApprovalDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "offerExtendedDate",
    label: "Offer Extended Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "offerExtendedDate",
      value: context.data.offerExtendedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "offerAcceptedDate",
    label: "Offer Accepted Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "offerAcceptedDate",
      value: context.data.offerAcceptedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "pendingStartDate",
    label: "Pending Start Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "pendingStartDate",
      value: context.data.pendingStartDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "withdrewDate",
    label: "Withdrew Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "withdrewDate",
      value: context.data.withdrewDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "declinedDate",
    label: "Declined Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "declinedDate",
      value: context.data.declinedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "declinedOfferRescindedDate",
    label: "Declined Offer Rescinded Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "declinedOfferRescindedDate",
      value: context.data.declinedOfferRescindedDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "declinedUnresponsiveDate",
    label: "Withdrew Unresponsive Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      dateKey: "declinedUnresponsiveDate",
      value: context.data.declinedUnresponsiveDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "hireDate",
    label: "Hired Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      isEditable: false,
      dateKey: "hireDate",
      value: context.data.hireDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "startDate",
    label: "Start Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      isEditable: false,
      dateKey: "startDate",
      value: context.data.startDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "termDate",
    label: "Term Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      isEditable: false,
      dateKey: "termDate",
      value: context.data.termDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  {
    key: "outsideRetentionPeriodDate",
    label: "Outside Retention Period Date",
    span: 12,
    component: CandidateDateField,
    getProps: (context, field) => ({
      label: field.label,
      isEditable: false,
      dateKey: "outsideRetentionPeriodDate",
      value: context.data.outsideRetentionPeriodDate,
      candidateJobEntryId: context.data.id,
      setCandidateActivity: context.setCandidateActivity,
      jobId: context.data.jobsourceId,
      candidateActivity: context.data,
      disabled: context.disabled,
    }),
  },
  ...getCandidateUdfFields(udf),
];
